import React from "react";
import SelectDropdown from "../../components-react/SelectDropdown";
import useGymsData from "../../../hooks/useGymsData";

const GymFilter = ({ selectedGym, setSelectedGym }) => {
  const { data: gymsData } = useGymsData();

  // Add a class based on whether a gym is selected
  const containerClass = `timesheet_dropdown_wrapper ${
    !selectedGym ? "empty-selection" : "has-selection"
  }`;

  return (
    <div className={containerClass}>
      <SelectDropdown
        options={gymsData?.length > 0 ? gymsData : []}
        name="Gym"
        value={selectedGym}
        setSelectedOption={setSelectedGym}
        isDisable={false}
        preventKeyboardOpen={false}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            borderColor: selectedGym
              ? "2px solid #28a745 !important"
              : "gray !important",
            "&:hover": {
              borderColor: selectedGym
                ? "2px solid #28a745 !important"
                : "gray !important",
            },
            boxShadow: state.isFocused
              ? "0 0 0 0.2rem rgba(0, 0, 0, 0.25) !important"
              : "none",
            borderRadius: "4px",
            color: "#28a745 !important",
          }),
        }}
      />
    </div>
  );
};

export default GymFilter;
